<template>
	<div>
		<header class="lmy-header lmy-header-w">
	        <i class="iconfont icon-back" onclick="window.history.go(-1)"></i>
	        收藏
	        <span class="cancel" @click="isManage=!isManage" v-if="!isManage">管理</span>
	        <span class="cancel" @click="isManage=!isManage" v-if="isManage">完成</span>
	    </header>
	   	<div class="lmy-withdraw" v-if="loading">
		    <div class="infinite-loading-containers" >
				<i class="loading-defaults"></i>
			</div>
		</div>
	    <div class="lmy-collect" v-if="!loading">

	        <div class="collect-box" v-for="hotel in list" >
	            <div :class="isManage?'check-box manage':'check-box'">
	                <input type="checkbox" v-model="hotel.isSelect" />
	            </div>
	            <div class="action-box">
	                <div class="share">分享</div>
	                <div class="delete">删除</div>
	            </div>
	            <!--点击导航栏管理后 给list-item 添加manage -->
	            <div :class="isManage?'list-item manage':'list-item'" @click="routeToDetails(hotel)">
	                <div class="item-img">
	                    <img src="./../../../assets/img/default-hotel.jpg" alt="" v-if="!hotel.Img">
	                    <img :src="hotel.Img|replaceImgSrc(3)" alt="" v-if="hotel.Img">
	                    <!-- <span class="tag"></span> -->
	                </div>
	                <div class="item-content">
	                    <h3 class="title">{{hotel.Name}}</h3>
	               
	                </div>
	            </div>
	        </div>
	        <div v-if="!list||list.length<=0" class="text-center">
	           	<label>您暂时没有收藏任何产品！</label> 
	        </div>
	 
	    </div>
	    <div class="lmy-bottom-btn" v-if="isManage" @click="remove">删除</div>
	</div>
</template>
<script>
	export default{
		name:'collect',
			data(){
			return{
				list:'',
				isManage:false,
				loading:true,
				comfirmInfo:{},
				CheckIn:this.getDate(1),
        		CheckOut:this.getDate(2),
			}
		},
		methods:{
			remove(){
				var list=this.list;
				var that=this;
			
				
				for(var i=0;i<list.length;i++){
				
					(function(i){
						
						if(list[i].isSelect){

							that.unsaveHotel(list,i);
						}
					})(i)
					// console.log(list[i].isSelect)
										
				}
			},
		   //取消收藏酒店
			unsaveHotel(list,i){

				var that=this;
	            var param={
	                ID:list[i].ID,
	            }
	            that.getRequest({
	                url:that.Api.removeFavorite, 
	                params:param
	            }).then(res => {
	                if(res){
	                	that.isHotelCorrect=false;
	                	list.splice(i,1);
	                    // that.error({title:'提示',content:'取消收藏成功'});
	                }
	            });
			},

			init(){
				var that=this;
				that.getRequest({
					this:this,
					url:that.Api.getFavorites, 
				}).then(res => {
					that.loading=false;
				    if(res&&res.Total>0){
				    	that.list=res.Result;
				    }
				});
			},
	        //进入详情页
	      	routeToDetails(item){
		        if(item.From==0){
		            var obj={
		                HotelID:item.ID,
		                ProductType:0,
		                From:0,
		                CheckIn:this.CheckIn,
		                CheckOut:this.CheckOut,
		                RoomCount:1,
		                AdultCount:2,
		                ChildrenCount:0,
		                ChildrenAges:'',
		            }
		            this.dao.set('frHotelDetailsParams',JSON.stringify(obj));
		            this.$router.push('/frHotelDetails');
		        }else{
			        var obj={
			            HotelID:item.ID,
			            ProductType:0,
			            From:1,
			            CheckIn:this.CheckIn,
			            CheckOut:this.CheckOut,
			            RoomCount:1,
			            AdultCount:2,
			            ChildrenCount:0,
			            ChildrenAges:'',
			        }
		          	this.dao.set('hotelDetailsParams',JSON.stringify(obj));
		          	this.$router.push('/hotelDetails');
		        }
	      	},
		},
		mounted(){
			this.init();
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/usr/collect/collect.vue